import React, { SetStateAction } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Link } from "react-router-dom";

import { useAppSelector } from "../../../hooks";
import { selectUser } from "../../../states/slices/authReducer";
import { USER_ICON } from "../../../assets";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

function ThumbnailSidebar({
  pageNumber,
  numberPages,
  setPageNumber,
  pdfFile,
}: {
  pageNumber: number;
  numberPages: number;
  setPageNumber: React.Dispatch<SetStateAction<number>>;
  pdfFile: string;
}) {
  const user = useAppSelector(selectUser);
  return (
    <div>
      <div className="w-full py-6 px-6 flex items-center  gap-x-3">
        <Link className="flex items-center gap-x-3 flex-col" to="/">
          <img
            src={user?.profile_photo ? user?.profile_photo : USER_ICON}
            alt="user"
            className="w-12 h-12 border-4 border-brand_blue rounded-full"
          />
          <h1 className="text-2xl font-semibold text-brand_blue flex items-baseline space-x-1">
            <span>PDF</span>
            <span className="text-gray-300 font-normal">Editor</span>
          </h1>
        </Link>
      </div>
      <div className="flex flex-col items-center mt-4 space-y-4 max-h-[450px]  shadow-border overflow-y-auto">
        {Array.from({ length: numberPages }, (_, index) => (
          <div className="flex flex-col items-center" key={index}>
            <button onClick={() => setPageNumber(index + 1)} type="button">
              <Document file={pdfFile} key={pdfFile}>
                <Page
                  className={`shadow border ${
                    pageNumber === index + 1 &&
                    "border-2 rounded border-blue-400"
                  }`}
                  onLoadSuccess={() => setPageNumber(index + 1)}
                  pageNumber={index + 1}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                  width={100} // smaller width for thumbnail
                />
              </Document>
            </button>
            <span className="text-sm mt-1 text-white">{index + 1}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ThumbnailSidebar;
